import { Injectable } from '@angular/core';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogPresenter {
  view!: ConfirmationDialogComponent;

  setView(view: ConfirmationDialogComponent): void {
    this.view = view;
  }

  onAccept(): void {
    this.view.actionAcceptTriggered.emit();
  }

  onCancel(): void {
    this.view.actionCancelTriggered.emit();
  }
}
